/** Shared max-width + horizontal padding for chat message columns. */
export const CHAT_COLUMN_CLASS =
  'mx-auto w-full max-w-3xl xl:max-w-4xl px-4 sm:px-5 lg:px-8'

/** Empty-state composer — slightly narrower than the message column. */
export const CHAT_EMPTY_STATE_CLASS =
  'mx-auto w-full max-w-lg sm:max-w-xl lg:max-w-2xl px-4 sm:px-6'

/** Per-message narrow wrapper (panel docked — hover row stays full width). */
export const CHAT_MESSAGE_NARROW_CLASS =
  'mx-auto w-full max-w-3xl xl:max-w-4xl flex flex-col'

/** Docked chat sidebar — composer footer (avoids viewport `lg:px-8` on a ~420px panel). */
export const CHAT_PANEL_COMPOSER_CLASS = 'mx-auto w-full max-w-none px-2'
